import React, { Component } from 'react'
import { connect } from 'react-redux'
import ContactMenu from './ContactMenu'
import Checkbox from 'material-ui/Checkbox'
import ContactConfirm from './ContactConfirm'
import * as ContactActions from '../actions/ContactActions'
import SparkMD5 from 'spark-md5'
import DialogContactConfirm from './DialogContactConfirm'
import { glasConfig } from '../constants/Config'
import $ from 'jquery'
import DialogShowImage from './DialogShowImage'
import DialogShowVideo from './DialogShowVideo'
import { isAndroid, isMobile } from 'react-device-detect'
import * as moment from 'moment'
import Loading from './Loading'
import Snackbar from 'material-ui/Snackbar'
import { LinkItUrl } from 'react-linkify-it'
import { processVideoFile, VIDEO_ERROR_MESSAGES } from './Contact/VideoPicker';

const CHECKED_YES = 1
const CHECKED_NO = 0

class ContactDetail extends Component {
	constructor(props) {
		super(props)
		this.state = {
			content: '',
			checked: CHECKED_YES,
			image: null,
			submitted: false,
			file: null,
			threadId: this.props.match.params.id,
			data: {},
			imageShow: '',
			loading: false,
			errImg: false,
			// STEL-1440: video upload state
			videoFile: null,
			videoDuration: null,
			videoMd5: null,
			videoProcessing: false,
			videoError: '',
			videoPreviewUrl: null,
			videoProgress: 0,
		}
		// Ref để cancel callback cũ khi chọn file mới
		this._processId = 0;
	}

	componentWillUnmount() {
		$('.secondary-header').removeClass('hiddenClass')
		$('.menu-header').removeClass('hiddenClass')
		$('.header-back').addClass('hiddenClass')
		$('.component-title').text('')
	}

	componentDidMount() {
		this.getDetailThread()
		$('.secondary-header').addClass('hiddenClass')
		$('#lead-nav').addClass('hiddenClass')
		$('.header-back').removeClass('hiddenClass')
		$('.component-title').text('お問い合わせ/返信内容')
	}

	getDetailThread() {
		const { dispatch, MyProfile } = this.props
		dispatch(
			ContactActions.getDetailThread({
				threadId: this.state.threadId,
				userId: MyProfile.data.fortuneTellerId,
			})
		)
	}

	componentDidUpdate(prevProps) {
		if (prevProps.Contact.detail.data !== this.props.Contact.detail.data) {
			this.setState({
				data: this.props.Contact.detail.data,
				loading: false,
			})
		}
		if (
			prevProps.Contact.resolve.data !== this.props.Contact.resolve.data
		) {
			this.getDetailThread()
		}
		if (prevProps.Contact.post.data !== this.props.Contact.post.data) {
			this.setState({ loading: false })
			window.location.reload()
		}
	}

	selectFile = (event) => {
		const file = event.target.files[0];
		if (!file) return;
		const fileType = file.type;

		// Nhánh 1: ảnh hợp lệ — cancel video nếu đang progress + thay thế
		if (fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg' || fileType === 'image/gif') {
			this._processId++;
			this.getImageData(file);
			this.setState({
				file,
				videoFile: null,
				videoDuration: null,
				videoMd5: null,
				videoProcessing: false,
				videoProgress: 0,
				videoError: '',
				videoPreviewUrl: null,
			});
			return;
		}

		// Nhánh 2: video hợp lệ (MP4 hoặc MOV)
		if (fileType === 'video/mp4' || fileType === 'video/quicktime') {
			const currentProcessId = ++this._processId;
			this.setState({ videoProcessing: true, videoError: '', videoProgress: 0, image: null });
			processVideoFile(file, {
				onProgress: (pct) => {
					if (this._processId === currentProcessId) {
						this.setState({ videoProgress: pct });
					}
				},
				onError: (code) => {
					if (this._processId !== currentProcessId) return;
					const newState = { videoError: VIDEO_ERROR_MESSAGES[code], videoProcessing: false };
					// Chỉ xóa preview nếu chưa có file hợp lệ trước đó
					if (!this.state.videoFile && !this.state.file) {
						newState.videoPreviewUrl = null;
					}
					this.setState(newState);
				},
				onSuccess: ({ compressedBlob, duration, md5Sum }) => {
					if (this._processId !== currentProcessId) return;
					const thumbUrl = URL.createObjectURL(compressedBlob);
					this.setState({
						file: null,
						videoFile: compressedBlob,
						videoDuration: duration,
						videoMd5: md5Sum,
						videoProcessing: false,
						videoPreviewUrl: thumbUrl,
					});
				},
			});
			return;
		}

		// Nhánh 3: video sai format → chỉ show lỗi, KHÔNG xóa file cũ
		if (fileType.startsWith('video/')) {
			this.setState({ videoError: VIDEO_ERROR_MESSAGES['invalid_format'], videoProcessing: false });
		} else {
			this.setState({ errImg: true });
		}
	}

	getImageData(file) {
		let fileReader = new FileReader()
		fileReader.readAsDataURL(file)
		fileReader.onload = (ev) => {
			this.setState({
				error: false,
				message: '',
				image: ev.target.result,
			})
		}
	}

	handleChangeContent(e) {
		const content = e.target.value
		this.setState({ content })
	}

	handleClick(type) {
		this.setState({ checked: type })
	}

	onSubmit = () => {
		const length = this.state.content.replace(/\s/g, '').length
		if (length <= 0) {
			this.setState({ inValidContent: true })
			return
		}
		this.setState({ submitted: true })
	}

	showDialog = () => {
		this.dialogConfirm.openDialog(() => this.onConfirm())
	}

	onConfirm() {
		const params = {};
		const { image, file, videoFile, content, checked, threadId } = this.state;
		const { dispatch, MyProfile } = this.props;
		this.setState({ loading: true });

		if (image) {
			// Upload ảnh — truyền file trực tiếp, action tự build FormData + md5
			params.file = file;
			params.fileType = 'image';
			params.body = content;
			params.userId = MyProfile.data.fortuneTellerId;
			params.userName = MyProfile.data.fortuneTellerName;
			params.reply = checked;
			params.threadId = threadId;
			dispatch(ContactActions.postFileQuestion(params));
		} else if (videoFile) {
			// STEL-1440: upload video
			params.file = videoFile;
			params.fileType = 'video';
			params.body = content;
			params.userId = MyProfile.data.fortuneTellerId;
			params.userName = MyProfile.data.fortuneTellerName;
			params.reply = checked;
			params.threadId = threadId;
			dispatch(ContactActions.postFileQuestion(params));
		} else {
			// Text only
			params.body = content;
			params.userId = MyProfile.data.fortuneTellerId;
			params.userName = MyProfile.data.fortuneTellerName;
			params.reply = checked;
			params.threadId = threadId;
			dispatch(ContactActions.postQuestion(params));
		}
	}

	onCancel = () => {
		this.setState({ submitted: false })
	}

	onResolveQuestion = () => {
		const { dispatch } = this.props
		dispatch(
			ContactActions.resolveQuestion({ threadId: this.state.threadId })
		)
	}

	showImage = (name, isS3, presignedUrl) => {
		// STEL-1440: nếu có presigned_url (S3) → dùng trực tiếp
		if (presignedUrl) {
			this.setState({ imageShow: presignedUrl });
		} else {
			// Logic cũ: ảnh từ Java server
			this.setState({ imageShow: glasConfig.url_image + '/' + name });
		}
		this.dialogShowImage.openDialog();
	}

	showVideo = (url) => {
		this.dialogShowVideo.openDialog(url);
	}

	//  isValidURL = (string)=> {
	// 	var res = string.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm);
	// 	if(res!==null){
	// 		return <a className="linkUrl" target="_blank" href={string}>{string}</a>
	// 	}
	// 	return string
	//   };

	render() {
		const { data } = this.state
		const regexToMatch = /@([\w_]+)/;

		return (
			<div className="content contactContent contactContentDetail">
				<h1 className="content__title hidden-sp">お問い合わせ</h1>
				<ContactMenu />
				<p className="contact-detail-title hidden-sp">
					お問い合わせ履歴 &gt; お問い合わせ/返信内容
				</p>
				{this.state.submitted ? (
					<ContactConfirm
						item={this.state}
						onCancel={this.onCancel}
						onConfirm={this.showDialog}
					/>
				) : (
					<div>
						<div className="primary contactPrimary">
							<div className="primary-title hidden-sp">
								<h1 className="primary-title__main">
									お問い合わせ/返信内容
								</h1>
							</div>
							<div className="support-wrap">
								<div className="support-content">
									{data.resultData &&
										data.resultData.map((item, index) => (
											<div className="support-detail-area" key={index}>
												{item['kind'] ==
													glasConfig.contact
														.kindUserSend ? (
													<div className="support-question">
														<p className="support-title">
															お問い合わせ内容
														</p>
														<div className="support-subject">{item.subject}</div>
														<div className="support-question-datetime">
															{moment(
																item[
																'senddate'
																],
																'YYYY-MM-DD HH:mm'
															).format(
																'YYYY/MM/DD HH:mm'
															)}
														</div>
														{(item.content !== '' && item.content !== null) &&
															<>
																<div className="support-content">ご利用環境</div>
																<div className="support-content">{item.content}</div>
															</>
														}
														<div className="support-question-content">
															<LinkItUrl
																component={(match, key) => <a href={match} key={key}>{match}</a>}
																regex={regexToMatch}
															>
																{item['body']}
															</LinkItUrl>
														</div>
														{item['images'].length >
															0 &&
															item['images'].map(
																(
																	image,
																	idx
																) => (
																	<div key={idx}>
																		{image.is_delete ? (
																			<span className="link-image" style={{ color: '#999', cursor: 'default' }}>
																				添付ファイルは削除されました
																			</span>
																		) : (
																			<a
																				onClick={() =>
																					this.showImage(
																						image.filename,
																						image.is_s3,
																						image.presigned_url
																					)
																				}
																				className="link-image"
																			>
																				添付ファイル
																			</a>
																		)}
																	</div>
																)
															)}
														{/* STEL-1440: render videos[] */}
														{item['videos'] && item['videos'].length > 0 &&
															item['videos'].map((video, idx) => (
																<div key={idx}>
																	{video.is_delete ? (
																		<span style={{ color: '#999', fontSize: 14 }}>
																			添付ファイルは削除されました
																		</span>
																	) : (
																		<a
																			onClick={() =>
																				this.showVideo(video.presigned_url)
																			}
																			className="link-image"
																		>
																			添付ファイル
																		</a>
																	)}
																</div>
															))
														}
													</div>
												) : (
													<div className="support-reply">
														<div className="support-reply-inner">
															<div className="support-reply-inner-top-admin">
																<div className="support-question-title">
																	{item[
																		're_send_id'
																	]
																		? 'カスタマーサポートからの返信'
																		: item[
																		'subject'
																		]}
																</div>
																<div className="support-question-datetime">
																	{moment(
																		item[
																		'senddate'
																		],
																		'YYYY-MM-DD HH:mm'
																	).format(
																		'YYYY/MM/DD HH:mm'
																	)}
																</div>
																<p className="support-question-content-admin">
																	<LinkItUrl
																		component={(match, key) => <a href={match} key={key}>{match}</a>}
																		regex={regexToMatch}
																	>
																		{item.body}
																	</LinkItUrl>
																</p>
															</div>
															{item['images']
																.length > 0 &&
																item[
																	'images'
																].map(
																	(
																		image,
																		idx
																	) => (
																		<div key={idx}>
																			{image.is_delete ? (
																				<span style={{ color: '#999', fontSize: 14, display: 'block' }}>
																					添付ファイルは削除されました
																				</span>
																			) : (
																				<a
																					onClick={() =>
																						this.showImage(
																							image.filename,
																							image.is_s3,
																							image.presigned_url
																						)
																					}
																					className="link-image"
																				>
																					添付ファイル
																					<br />
																				</a>
																			)}
																		</div>
																	)
																)}
															{/* STEL-1440: render videos[] in admin reply */}
															{item['videos'] && item['videos'].length > 0 &&
																item['videos'].map((video, idx) => (
																	<div key={idx}>
																		{video.is_delete ? (
																			<span style={{ color: '#999', fontSize: 14, display: 'block' }}>
																				添付ファイルは削除されました
																			</span>
																		) : (
																			<a
																				onClick={() =>
																					this.showVideo(video.presigned_url)
																				}
																				className="link-image"
																			>
																				添付ファイル
																				<br />
																			</a>
																		)}
																	</div>
																))
															}
														</div>
														{!data.isClose && (
															<div className="support-reply-confirm">
																<span classname="support-reply-text">
																	この内容で解決しましたか？
																</span>
																<button
																	onClick={
																		this
																			.onResolveQuestion
																	}
																>
																	解決した
																</button>
															</div>
														)}
													</div>
												)}
											</div>
										))}
								</div>
							</div>
						</div>
						<div className="primary contactPrimary">
							<div className="primary-title" style={isMobile ? { paddingLeft: 15, paddingTop: 3 } : {}}>
								<h1 className="primary-title__main title-contact-rep">
									返信フォーム
								</h1>
							</div>
							<p className="titleTextBox">お問い合わせ内容</p>
							<textarea
								className="inputCus inputContact"
								onChange={(e) => this.handleChangeContent(e)}
								placeholder="具体的にお問い合わせ内容をご記入ください。 スクリーンショットを添付いただきますと対応がスムーズになります。"
								value={this.state.content}
							/>
							{this.state.inValidContent && (
								<p className="errMsgContact">
									お問い合わせ内容を入力してください
								</p>
							)}
							<div className="fileContact" style={{ marginBottom: 44 }}>
								<div className="btn-wrap btnFile">
									<label className="btn-raised color_white">
										<p className="btn-raised__text">
											ファイルを選択
										</p>
										<input
											type="file"
											className="btn-raised__file inputChooseFile"
											accept="image/png,image/jpeg,image/jpg,image/gif,video/mp4,video/quicktime"
											onChange={(e) => this.selectFile(e)}
										/>
									</label>
								</div>
								<p className="txtFileContact">
									{this.state.image
										? '写真1枚'
										: this.state.videoFile ? '動画1本' : 'ファイル未選択'}
								</p>
								{this.state.image && (
									<img
										src={this.state.image}
										className="imageContact"
										alt="preview"
									/>
								)}
								{/* Progress nén video */}
								{this.state.videoProcessing && (
									<div className="txtFileContact" style={{ marginTop: 18 }}>
										<p>動画を処理中... {this.state.videoProgress}%</p>
										<div style={{ width: 100, height: 6, background: '#e0e0e0', borderRadius: 3, overflow: 'hidden' }}>
											<div style={{ width: `${this.state.videoProgress}%`, height: '100%', background: '#11ad9d', transition: 'width 0.3s' }} />
										</div>
									</div>
								)}
								{/* Preview video */}
								{this.state.videoPreviewUrl && !this.state.videoProcessing && (
									<div style={{ position: 'relative', display: 'inline-block', marginTop: 8, marginLeft: 32 }}>
										<video
											src={this.state.videoPreviewUrl}
											style={{ width: 100, height: 'auto', display: 'block' }}
										/>
										<span style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											fontSize: 32,
											color: 'white',
											textShadow: '0 0 4px #000',
											pointerEvents: 'none',
										}}>▶</span>
									</div>
								)}
								{/* Error video — dùng Snackbar bên dưới */}
							</div>
							<p className="titleTextBox">返信の有無</p>
							<div
								className={
									isAndroid
										? 'checkBoxContact checkBoxContactAndroid'
										: 'checkBoxContact checkBoxContactIOS'
								}
							>
								<Checkbox
									label="必要"
									onCheck={(e) =>
										this.handleClick(CHECKED_YES)
									}
									checked={this.state.checked === CHECKED_YES}
									style={{ color: '#c7bfbf' }}
									// iconStyle={{fill:'rgba(17, 173, 157, 1)' }}
									labelStyle={{ fontWeight: 'normal' }}
								/>
								<Checkbox
									label="不要"
									onCheck={(e) =>
										this.handleClick(CHECKED_NO)
									}
									checked={this.state.checked === CHECKED_NO}
									style={{ color: '#c7bfbf' }}
									// iconStyle={{fill:'rgba(17, 173, 157, 1)' }}
									labelStyle={{ fontWeight: 'normal' }}
								/>
							</div>
							<button
								onClick={this.onSubmit}
								className="submitContact"
								disabled={this.state.videoProcessing}
							>
								内容確認
							</button>
						</div>
					</div>
				)}
				<DialogContactConfirm
					ref={(dialog) => (this.dialogConfirm = dialog)}
				/>
				<DialogShowImage
					ref={(dialog) => (this.dialogShowImage = dialog)}
					imageShow={this.state.imageShow}
				/>
				<DialogShowVideo
					ref={(dialog) => (this.dialogShowVideo = dialog)}
				/>
				<Loading display={this.state.loading} />
				<Snackbar
					open={this.state.errImg}
					message={'ファイル形式が不正です。画像（PNG/JPG/GIF）または動画（MP4/MOV）を選択してください。'}
					autoHideDuration={2500}
					onRequestClose={() => this.setState({ errImg: false })}
				/>
				{/* STEL-1440: Snackbar lỗi video */}
				<Snackbar
					open={!!this.state.videoError}
					message={this.state.videoError}
					autoHideDuration={3000}
					onRequestClose={() => this.setState({ videoError: '' })}
				/>
			</div>
		)
	}
}

const mapStateToProps = (store) => {
	return {
		MyProfile: store.MyProfile,
		Contact: store.Contact,
	}
}

export default connect(mapStateToProps)(ContactDetail)
